// Условия показа вопросов. Совпадает с backend app/adaptation/builder/logic.py::condition_matches.
// [Claude] 2026-11-02 (Чат 3, №7): добавлены lt / gte / gt / ne / answered / delta_down_gte / delta_up_gte / all.

const YES = "да";
const NO = "нет";

function asList(value) {
    if (Array.isArray(value)) return value;
    if (value == null || value === "") return [];
    return [value];
}

function asNumber(value) {
    if (typeof value === "boolean" || value == null || value === "") return null;
    if (value === YES) return 1;
    if (value === NO) return 0;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
}

export function matchRule(rule, values, coreHistory) {
    if (!rule || typeof rule !== "object") return true;
    if (Array.isArray(rule.any)) return rule.any.some((item) => matchRule(item, values, coreHistory));
    if (Array.isArray(rule.all)) return rule.all.every((item) => matchRule(item, values, coreHistory));
    const field = rule.field;
    const raw = values?.[field];
    const has = (key) => Object.prototype.hasOwnProperty.call(rule, key);
    if (has("answered")) {
        const filled = !(raw == null || raw === "" || (Array.isArray(raw) && raw.length === 0));
        return filled === Boolean(rule.answered);
    }
    if (has("eq")) return String(raw) === String(rule.eq);
    if (has("ne")) return !(raw == null || raw === "") && String(raw) !== String(rule.ne);
    if (rule.in) return asList(raw).some((v) => rule.in.includes(v));
    if (rule.not_in) return !(raw == null || raw === "") && !rule.not_in.includes(raw);
    if (rule.not_only) {
        const list = asList(raw);
        if (!list.length) return false;
        return !(list.length === 1 && rule.not_only.includes(list[0]));
    }
    const current = asNumber(raw);
    for (const op of ["lte", "lt", "gte", "gt"]) {
        if (rule[op] != null) {
            if (current == null) return false;
            const limit = Number(rule[op]);
            if (op === "lte") return current <= limit;
            if (op === "lt") return current < limit;
            if (op === "gte") return current >= limit;
            return current > limit;
        }
    }
    for (const op of ["delta_gte", "delta_down_gte", "delta_up_gte"]) {
        if (rule[op] != null) {
            const prev = asNumber(coreHistory?.[field]);
            if (current == null || prev == null) return false;
            const delta = current - prev;
            const limit = Number(rule[op]);
            if (op === "delta_gte") return Math.abs(delta) >= limit;
            if (op === "delta_down_gte") return -delta >= limit;
            return delta >= limit;
        }
    }
    return true;
}

export function isQuestionVisible(question, values, coreHistory = {}) {
    const rule = question?.show_if;
    if (!rule) return true;
    return matchRule(rule, values, coreHistory);
}
